var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"app-badge",attrs:{"href":"https://play.google.com/store/apps/details?id=pl.jaty.twa&gl=PL","target":"_blank","rel":"nofollow"}},[_c('img',{attrs:{"src":_vm.$t('images.play_badge'),"width":"180","height":"54","alt":"download from google play"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }